import { Radio as AntdRadio, RadioProps as AntdRadioProps } from 'antd';
import { forwardRef } from 'react';
import type { ElementRef } from 'react';

interface AppRadioProps extends Omit<AntdRadioProps, 'ref'> {
  // Add any additional custom props here if needed
}

type AntdRadioRef = ElementRef<typeof AntdRadio>;

/**
 * AppRadio is a wrapper around Ant Design's Radio component that ensures consistent
 * styling and behavior across the application.
 *
 * @component
 * @example
 * <AppRadio value="option1">Option 1</AppRadio>
 */
const AppRadio = forwardRef<AntdRadioRef, AppRadioProps>((props, ref) => {
  return <AntdRadio ref={ref} {...props} />;
});

AppRadio.displayName = 'AppRadio';

export default AppRadio;
